export const verifyEmailStepCountStyle = theme => ({
  root: {
    width: '100%',
  },
  infotext: {
    '& a': {
      color: '#00f !important',
    },
    '& p': {
      marginTop: '0.1em',
      marginBottom: '0.1em',
    },
  },
})
